const state = {
    id: null,
    name: null,
    email: null,
    token: null,
    isAdmin: null,
    teams: []

}

const getters = {
    isLoggedIn(state) {
        return !!state.token;
    },
}
const actions = {
    setUserId({ commit }, data) {
        commit('setUserId', data)
    },
    setUserName({ commit }, data) {
        commit('setUserName', data)
    },
    setUserEmail({ commit }, data) {
        commit('setUserEmail', data)
    },
    setUserToken({ commit }, data) {
        commit('setUserToken', data)
    },
    setUserIsAdmin({ commit }, data) {
        commit('setUserIsAdmin', data)
    },
    setUserTeams({ commit }, data) {
        commit('setUserTeams', data)
    }
}
// mutations
const mutations = {
    setUserId(state, playload) {
        state.id = playload
    },
    setUserName(state, playload){
        state.name = playload
    },
    setUserEmail(state, playload){
        state.email = playload
    },
    setUserToken(state, playload){
        state.token = playload
    },
    setUserIsAdmin(state, playload){
        state.isAdmin = playload
    },
    setUserTeams(state, playload){
        state.teams = playload
    }
}

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations
}